import { Message } from '../connector/Interface';

export type SurfaceTreatment = {
    stId: string;
    stName: string;
    thickness: string;
    density: string;
    adb?: string;
}

export type MaterialColor = {
    conditionId: number | string;
    code: string;
    legacyCode: string;
    colorLabel: string;
    color: string;
}

export type MaterialDimension = {
    conditionId: number | string;
    code: string;
    legacyCode: string;
    dimensionDefinition: string;
    dimensionUnit: string;
    dimensionValue: string;
}

export type MaterialProperties = {
    surfaceTreatments: SurfaceTreatment[];
    colors: MaterialColor[];
    dimensions: MaterialDimension[];
    name?: string;
    adb?: string;
    version?: string;
    density?: string;
}

export type InboundAlternate = {
    bmId: string;
    bmName?: string;
    bmDensity?: string;
    abbId?: string | null;
    conditionType?: 'color' | 'dimension' | null;
    condition?: MaterialColor | MaterialDimension | null;
}

export type InternalAlternate = {
    bmId?: string;
    bmName?: string;
    bmDensity?: string;
    abbId?: string | null;
    partNr?: string;
    conditionType?: string | null;
    conditionCode?: string | null;
    condition?: MaterialColor | MaterialDimension | null;
}

export type InboundPartnr = {
    partnr: string;
    bmId?: string;
    stMaterialId?: string;
    bmDensity?: string;
    bmName?: string;
    stName?: string;
    isAssembly: boolean;
    stDensity?: string,
    coverage?: string,
    thickness?: string,
    alternates?: InboundAlternate[];
}

export class PartNrMessage extends Message{
    static type = "abb.PartNrMessage" as const;
    static version = 1 as const;
    partNrs: InboundPartnr[];
    constructor(partnrs: InboundPartnr[]){
        super();
        this.partNrs = partnrs;
    }
}

export type UnitValue = {
    value: string;
    unit: string;
}



export type AlternateMaterial = {
    /** Unique row ID for the alternates table */
    id: string;
    /** Partnr of the primary part this alternate belongs to */
    partNr: string;
    materialId: string;
    materialName: string;
    /** ABB-specific prefix (adb), stored separately from the material name.
     * undefined = not yet fetched, null = fetched (no prefix), string = prefix */
    abbId?: string | null;
    materialDensity?: string;
    conditionType: 'color' | 'dimension' | null;
    condition: MaterialColor | MaterialDimension | null;
}

export type Assignment = {
    bmId: string;
    partNr?: string;
    stMaterialId: string | null;
    stThickness: UnitValue | null;
    stCoverage: UnitValue | null;
    stDensity: UnitValue | null;
    bmDensity: UnitValue | null;
    bmName: string;
    stName: string | null;
    conditionType: string | null;
    condition: MaterialColor | MaterialDimension | null;
}

export class AssignmentMessage extends Message{
    static type = "abb.AssignmentMessage" as const;
    static version = 2 as const;
    assignment: Assignment;
    assignments: Assignment[] = [];
    alternates: AlternateMaterial[] = [];
    constructor(assignment: Assignment, alternates: AlternateMaterial[] = []) {
        super();
        this.assignment = assignment;
        this.assignments.push(assignment);
        this.alternates = alternates;
    }
}

export type Material = {
    id: string;
    name?: string;
    density?: string;
    adb?: string;
}

